import { useState } from "react";
import { useQuery } from "react-query";
import { Filters, listAllPreBudgetsUnit } from "Requests/Partners/PreBudgets";

export type FiltersState = Omit<Filters, "page">;

export const usePreOrderList = () => {
  const [pageSelected, setPageSelected] = useState(1);

  const [filters, setFilters] = useState<FiltersState>({
    search: "",
    start_date: undefined,
    end_date: undefined,
    status_id: [1],
    client_id: null,
    state: "",
  });

  const { end_date, search, start_date, client_id, status_id, state } = filters;

  const filtersRequest = {
    search,
    start_date: start_date?.format("YYYY-MM-DD"),
    end_date: end_date?.format("YYYY-MM-DD"),
    page: pageSelected,
    status_id,
    client_id,
    state,
  };

  const preBudgetList = useQuery({
    queryFn: () =>
      listAllPreBudgetsUnit({ ...filtersRequest, per_page: "150" }),
    queryKey: [
      "listAllPreBudget-units",
      pageSelected,
      {
        ...filters,
      },
    ],
    refetchOnWindowFocus: false,
  });

  const setProductFilters = (searchFilter: FiltersState) => {
    setFilters({ ...searchFilter });
  };

  const setNewPage = (page: number) => {
    setPageSelected(page);
  };

  function handlePagination(e: { currentPage: number }) {
    if (pageSelected === e.currentPage) return;
    setNewPage(e.currentPage);
  }

  return {
    preBudgetList,
    setNewPage,
    setProductFilters,
    handlePagination,
  };
};
